import script from "./welcomeScreenSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./welcomeScreenSwitch.vue?vue&type=script&setup=true&lang=js"

import "./welcomeScreenSwitch.vue?vue&type=style&index=0&id=999d393a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-999d393a"]])

export default __exports__